// =============================================================================
// Repository: CreateProject — project creation via edge function + logo upload
// =============================================================================

import { supabase } from '@/integrations/supabase/client';

const BUCKET_NAME = 'project-logos';

export interface CreateProjectParams {
  orgId: string;
  name: string;
  description?: string | null;
  startDate?: string | null;
  dueDate?: string | null;
  spaceId?: string | null;
  visibility?: 'public' | 'private';
  sharedMemberIds?: string[];
}

export async function createProjectViaEdgeFunction(params: CreateProjectParams) {
  const { data, error } = await supabase.functions.invoke('create-project', {
    body: {
      org_id: params.orgId,
      name: params.name,
      description: params.description || null,
      start_date: params.startDate || null,
      due_date: params.dueDate || null,
      space_id: params.spaceId || null,
      visibility: params.visibility || 'public',
      shared_member_ids: params.sharedMemberIds || [],
    },
  });

  if (error) throw new Error(error.message || 'Erreur lors de la création du projet');
  if (!data?.success || !data?.project) {
    throw new Error(data?.error || 'Erreur lors de la création du projet');
  }

  return data.project;
}

export async function uploadNewProjectLogo(
  orgId: string,
  projectId: string,
  file: File,
): Promise<void> {
  const fileExt = file.name.split('.').pop();
  const filePath = `${orgId}/${projectId}/logo.${fileExt}`;

  const { error: uploadError } = await supabase.storage
    .from(BUCKET_NAME)
    .upload(filePath, file, { upsert: true });

  if (uploadError) {
    console.error('Error uploading logo:', uploadError);
    return;
  }

  const { data: urlData } = supabase.storage
    .from(BUCKET_NAME)
    .getPublicUrl(filePath);

  const { error: updateError } = await supabase
    .from('project_projects')
    .update({ logo_url: urlData.publicUrl })
    .eq('id', projectId);

  if (updateError) {
    console.error('Error updating project logo_url:', updateError);
  }
}
